import { useState, useEffect } from 'react';
import { useUserData } from './useUserData';
import { getValidationDetails } from '../api/validationService';

export const useValidationDetails = (entityId, entityType) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getUserInfo } = useUserData();
  const [currentUserAccountId, setCurrentUserAccountId] = useState(null);
  const [isValidationManager, setIsValidationManager] = useState(false);

  useEffect(() => {
    const loadDetails = async () => {
      if (!entityId || !entityType) return;

      try {
        setLoading(true);
        setError(null);
        
        // Charger les détails complets
        const validationDetails = await getValidationDetails(entityId, entityType);
        // console.log("detail selectionner",validationDetails);
        setDetails(validationDetails);

        // Récupérer les infos de l'utilisateur connecté
        const userInfo = await getUserInfo();
        if (userInfo) {
          setCurrentUserAccountId(userInfo.accountId);
          setIsValidationManager(userInfo.isValidationManager || false);
        }
      } catch (error) {
        // console.error("Erreur détaillée:", error);
        setError(error.message || "Erreur lors du chargement des détails");
      } finally {
        setLoading(false);
      }
    };

    loadDetails();
  }, [entityId, entityType, getUserInfo]);

  const retry = () => {
    setError(null);
    setLoading(true);
    // Le useEffect se relancera automatiquement
  };

  return {
    details,
    loading,
    error,
    currentUserAccountId,
    isValidationManager,
    retry
  };
};